__turbopack_context__.v({
  "className": "season_be3a96a5-module__n3o7CG__className",
  "variable": "season_be3a96a5-module__n3o7CG__variable",
});
